<template>
    <div class="head-img">
        <img v-if="avatar" :src="avatar" alt="" :style="{'width': width + 'px', 'height': height + 'px', 'top': top + 'px'}" class="person-img mr5" :class="{'man-border': sex === 1, 'woman-border': sex === 2, 'radius': radius}">
        <svg class="iconSymbol mr5" aria-hidden="true" :style="{'fontSize': width + 'px', 'top': top + 'px'}" v-else>
			<use xlink:href="#iconmorentouxiang" />
		</svg>
    </div>
</template>

<script>
export default {
    props: {
        avatar: {
            type: String,
            default: ''
        },
        width: {
            type: Number,
            default: 24
        },

        height: {
            type: Number,
            default: 24
        },

        sex: {
            type: Number,
            default: 0
        },

        radius: {
            type: Boolean,
            default: false,
        },

        top: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss" scoped>
.head-img {
    display: inline-block;
    padding: 1px 0;
}
.person-img {
    vertical-align: bottom;
    position: relative;
}
.iconSymbol {
    position: relative;
}
.radius {
    border-radius: 50%;
}
</style>